<template>
  <the-scroll>
    <!-- Dynamic Header -->
    <dynamic-header />

    <div
      v-if="isPreview"
      class="preview-banner">
      🔍 Preview Mode Active
    </div>
    <main :class="['main-content', { '-header-height': headerSpace }]">
      <slot />
    </main>
    <div
      v-show="!layoutStore.isLanding"
      class="l-wrapper">
      <horizontal-card
        :title="$t('dealer.info.needMoreInfo')"
        :description="null"
        :image-src="horizontalImage"
        :image-avif="horizontalImageAvif"
        :image-webp="horizontalImageWebp"
        :primary-cta-text="$t('dealer.cta.contacts')"
        :secondary-cta-text="$t('dealer.cta.findDealer')"
        :show-ctas="true" />
    </div>
    <the-footer-brand-only v-if="layoutStore.isLanding" />
    <the-footer v-show="!layoutStore.isLanding" />
  </the-scroll>
  <the-notifications />
</template>

<script setup>
  import horizontalImageAvif from '~/assets/images/horizontal.avif'
  import horizontalImage from '~/assets/images/horizontal.jpg'
  import horizontalImageWebp from '~/assets/images/horizontal.webp'

  const { isPreview } = usePreview()
  const layoutStore = useLayoutStore()

  const headerSpace = computed(() => layoutStore.headerSpace)

  // Accept any props that might be passed to the layout
  defineProps({
    error: {
      type: Object,
      default: null
    }
  })
</script>

<style lang="scss">
.main-content {
  --header-height: 70px;

  &.-header-height {
    // padding-top: var(--header-height);
  }
}

.preview-banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 12px;
  font-size: 10px;
  line-height: 12px;
  text-align: center;
  background-color: #ffeb3b;
  z-index: 9999;
}
</style>
